<template>
    <div class="selectCourt fd-com-white-bg">
        <MyTitle theTitle="请选择案由"/>
            <div class="fd-select-court">
                <span>选择案由：</span>
                <span class="red-font">{{checkboxGroup.nameList.join(",")}}</span>
            </div>
            <!-- disabled -->
            <div class="fd-com-scroll">
               <!-- <template v-if="key123===2020">-->
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.gjfyList" :key="index">
                            <!--<van-checkbox v-model="item.checked" shape="square" @click="toggle(item,index)">{{item.name}}</van-checkbox>-->
                            <van-checkbox v-model="item.checked" shape="square">{{item.name}}</van-checkbox>
                            <div class="ul" v-if="item.children.length>0">
                                <div class="li" v-for="(item2,index2) in item.children" :key="index+String(index2)">
                                    <van-checkbox v-model="item2.checked" shape="square">{{item2.name}}</van-checkbox>
                                </div>
                            </div>
                        </li>
                    </ul>
                <!--</template>
                <template v-else>
                    <van-tabs style="height: 70%;" v-model="active">
                        <van-tab title="一级案由">
                            <ul class="fd-court-list">
                                <li v-for="(item,index) in info.gjfyList" :key="index" @click="toggle(item,index)">
                                    <van-checkbox v-model="item.checked" shape="square">{{item.name}}</van-checkbox>
                                </li>
                            </ul>
                        </van-tab>
                    </van-tabs>

                </template>-->
            </div>
            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    round
                    @click="sureBth">
                    确定
                </van-button>
            </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'

    export default {
        data() {
            return {
                info: {
                    checkedFy: "",
                    checkedFyId: "",
                    cId: "",
                    gjfyList: [],
                    zjfyList: [],
                },
                active: 0,
                arr: [],
                arrId: [],
                arrStr: "",
                // key:2020
            }
        },
        components: {
            MyTitle,
        },
        computed: {
            checkboxGroup(){
                var nameList=[];
                var idList=[];
                this.info.gjfyList.map(item=>{
                    //console.log('--item',item);
                    if(item.checked){
                        nameList.push(item.name);
                        idList.push(item.id);
                    }
                    item.hasOwnProperty('children')&&item.children.length>0&&item.children.map(item2=>{
                        if(item2.checked){
                            nameList.push(item2.name);
                            idList.push(item2.id);
                        }
                    });
                });
                return {nameList,idList};


                /*return this.info.gjfyList.filter(item=>item.checked).reduce(function (prev, cur) {
                    prev.nameList.push(cur.name)
                    prev.idList.push(cur.id)
                    return prev
                }, {
                    nameList: [],
                    idList: []
                })*/
            }
        },
        methods: {
            creatData() {
                let ayxw = sessionStorage.getItem('Ayxw')
                if(ayxw){
                    this.arr = JSON.parse(ayxw)
                    this.arrId = JSON.parse(sessionStorage.getItem('AyxwId'))
                }
                let ajlx = sessionStorage.getItem("nAjlx")
                //let cAyxzxw = sessionStorage.getItem("Aysz")

                let cAhNf =  sessionStorage.getItem("cAhNf")||2020
                var key=(cAhNf>=2021)?2021:2020;

                console.log('--creatData 222',ajlx+'2');
                //console.log('--creatData 333',cAyxzxw);
                console.log('--creatData 444',cAhNf);
                console.log('--creatData 555',key);

                let ayListAll = sessionStorage.getItem('ayListAll');
                console.log('--ayListAll 111',ayListAll);
                if(ayListAll){
                    this.ayListAll=JSON.parse(ayListAll);
                    this.info.gjfyList=this.ayListAll[key][62][0].children.map(item=>{
                            item.checked = this.arrId.indexOf(item.id)>-1
                            return item
                        }
                    );
                }else{
                    this.$axios.get('ssbq/api/bqsqs/new/ay').then(res => {
                        console.log('--res 000', res);
                        this.ayListAll = res.data;
                        this.info.gjfyList=this.ayListAll[key][62][0].children.map(item=>{
                                item.checked = this.arrId.indexOf(item.id)>-1
                                item.children.map(item2=>{
                                    item2.checked = this.arrId.indexOf(item2.id)>-1
                                })
                                return item
                            }
                        );
                        console.log('--this.info.gjfyList 000',this.info.gjfyList);
                    })
                }

                /*this.$axios.get('ssbq/api/bqsqs/ay?ajlx=' + ajlx + '&xzlx=' + cAyxzxw).then(res => {
                    this.ayData = res.data
                    //给一级案由赋值
                    this.info.gjfyList = this.ayData[0].children.map(item=>{
                        item.checked = this.arrId.indexOf(item.id)>-1
                        return item
                    })
                })*/
            },
            //选择行政行为
            toggle(item, index) {
                item.checked = !item.checked
            },
            //点击确定按钮
            sureBth() {
                sessionStorage.setItem('Ayxw', JSON.stringify(this.checkboxGroup.nameList))
                sessionStorage.setItem('AyxwId', JSON.stringify(this.checkboxGroup.idList))
                this.$router.go(-1)
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.creatData();
            })
        }
    }
</script>

<style lang="less" scoped>
    .selectCourt {
        width: 100%;
        height: 100%;
    }

    .fd-select-court {
        box-sizing: border-box;
        padding: 0 10px;
        line-height: 50px;
        display: flex;
    }

    .fd-xzfy-top {
        display: flex;
        box-sizing: border-box;
        padding: 0 20px;
        justify-content: space-between;

        > button {
            background: #fff;
            cursor: pointer;
        }
    }

    .fd-court-list {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 10px;

        > li {
            width: 100%;
            box-sizing: border-box;
            padding-top: 15px;
            /*height: 50px;*/
            line-height: 50px;
            cursor: pointer;
            border-bottom: 1px solid #eaeaea;

            .ul{
                /*border: 1px blue solid;*/
                margin-top: 15px;
                >.li{
                    /*border:1px red solid;*/
                    width: 100%;
                    box-sizing: border-box;
                    padding-top: 5px;
                    padding-left: 30px;
                    height: 30px;
                    line-height: 30px;
                    cursor: pointer;
                    border-top: 1px solid #eaeaea;
                }
            }
        }

    }

    .red-font {
        color: red;
        display: block;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
